class Darkmode {

  /* ========================================================================
   * Darkmode.js
   * ======================================================================== */
  constructor( el ) {
    this.el = el;
  }



  async init(){
    let darkmode = this;

    if( Cookies.get('darkmode') ){
      darkmode.el.checked = true;
    }

    darkmode.el.addEventListener('click',function(){

      if(darkmode.el.checked == true){
        document.body.classList.add('darkmode');
        Cookies.set( 'darkmode',1, { domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' } );
      }
      else{
        if( Cookies.get('darkmode') ){
          document.body.classList.remove('darkmode');
          Cookies.remove( 'darkmode', { domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' } );
        }
      }
    })
  }
}


DOMReady( function(){

  if( Cookies.get('darkmode') ){
    document.body.classList.add('darkmode');
  }

  [... document.querySelectorAll('.check-darkmode')].map( elt => {
    let darkmode = new Darkmode(elt);
    darkmode.init();
  });


});
